import React from "react";
import "./PrivacyPolicy.css"; 

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Нууцлалын бодлого</h1>
        <p>
          “Nairamdal” аппликейшн нь хэрэглэгчдийн хувийн мэдээллийг хамгаалахыг чухалчилдаг.
        </p>

        <h2>Бид дараах мэдээллийг цуглуулдаг:</h2>
        <ul>
          <li>Овог, нэр</li>
          <li>Регистрийн дугаар</li>
          <li>Хүйс</li>
          <li>Төрсөн он, сар, өдөр</li>
          <li>Хэрэглэгчийн утасны дугаар</li>
          <li>Имэйл хаяг</li>
          <li>Эцэг эхийн утасны дугаар</li>
          <li>Гэрийн хаяг</li>
          <li>Сургууль, анги</li>
        </ul>

        <h2>Мэдээллийг цуглуулах зорилго:</h2>
        <ul>
          <li>Хүүхдийн бүртгэлийг баталгаажуулах</li>
          <li>Үйлчилгээний хүртээмжийг сайжруулах</li>
          <li>Холбогдох мэдээллийг буцаан өгөх</li>
        </ul>

        <h2>Гуравдагч этгээдтэй мэдээлэл хуваалцах:</h2>
        <p>
          Бид таны мэдээллийг гуравдагч этгээдэд зарахгүй. Хэрвээ Firebase, Google Analytics зэрэг үйлчилгээ ашигласан бол таны өгөгдөл тухайн үйлчилгээний бодлогод нийцэн дамжиж болно.
        </p>

        <h2>Таны эрх:</h2>
        <p>
          Та бидэнд хүсэлт гаргаж өөрийн өгөгдлийг үзэх, засварлах эсвэл устгуулах эрхтэй.
        </p>

        <h2>Холбоо барих:</h2>
        <p>
          Хэрэв танд асуулт байгаа бол дараах хаягаар холбогдоно уу:
          <br />
          <strong>Email:</strong> info@nairamdal.mn
        </p>

        <p className="updated">Сүүлийн шинэчлэлт: 2025 оны 6-р сар</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
